export default `<g fill="currentColor">
<rect x="1.2" y="8.3" width="4.7" height="14.2"/>
<path d="M3.6,1.5C2,1.5,1,2.5,1,3.9s1,2.5,2.6,2.5l0,0c1.6,0,2.7-1.1,2.7-2.5S5.3,1.5,3.6,1.5z"/>
<path d="M17.6,8c-2.5,0-3.6,1.4-4.3,2.3v-2H8.6c0.1,1.3,0,14.2,0,14.2h4.7v-7.9c0-0.4,0-0.9,0.2-1.2c0.3-0.8,1.1-1.7,2.4-1.7
    c1.7,0,2.4,1.3,2.4,3.2v7.6H23v-8.2C23,10,20.7,8,17.6,8z"/>
</g>`;
